export const DRIVER_LOGIN_EMAIL_DOMAIN = 'login.paddiq';

const USERNAME_PATTERN = /^[a-z0-9][a-z0-9._-]{2,31}$/;

const RESERVED_USERNAMES = new Set([
  'admin',
  'api',
  'help',
  'login',
  'paddiq',
  'root',
  'support',
  'team',
]);

export function normalizeUsername(value: string) {
  return value.trim().toLowerCase();
}

export function isValidUsername(value: string) {
  const normalized = normalizeUsername(value);
  return USERNAME_PATTERN.test(normalized) && !RESERVED_USERNAMES.has(normalized);
}

export function driverLoginEmailFromUsername(username: string) {
  return `${normalizeUsername(username)}@${DRIVER_LOGIN_EMAIL_DOMAIN}`;
}

export type UsernameAvailabilityReason = 'invalid' | 'reserved' | 'taken';

export interface UsernameAvailabilityResult {
  available: boolean;
  username: string;
  reason?: UsernameAvailabilityReason;
}

export function validateUsernameAvailabilityInput(username: string): UsernameAvailabilityResult {
  const normalized = normalizeUsername(username);
  if (!normalized) {
    return { available: false, username: normalized, reason: 'invalid' };
  }

  if (!USERNAME_PATTERN.test(normalized)) {
    return { available: false, username: normalized, reason: 'invalid' };
  }

  if (RESERVED_USERNAMES.has(normalized)) {
    return { available: false, username: normalized, reason: 'reserved' };
  }

  return { available: true, username: normalized };
}

export function displayDriverLogin(driver: { username?: string | null; email: string }) {
  return driver.username?.trim() || driver.email;
}
